import { useQuery } from '@tanstack/react-query'
import { EmptyState, Text } from '@cinesend/ui-kit'
import DataTable from '../data_table'
import useTableFilters from '../../hooks/use_table_filters'
import { convertToDateTime } from '../../helpers/convert_date'
import { Link } from 'react-router-dom'
import useAuth from '../../hooks/use_auth'

const sortingOptions = [
  { label: 'Created at', key: 'created_at' },
  { label: 'Description', key: 'description' },
]

export default function ActivityLogsTable({ queryKey }) {
  const { user } = useAuth()
  const { queryString, searching, sorting, filtering, pagination } = useTableFilters({
    sortingOptions,
    enableSearch: true,
  })
  const { data, error, isLoading, refetch } = useQuery([`activity-logs${queryKey ? `?${queryKey}` : ''}`, queryString])

  const columns = [
    {
      key: 'user',
      header: 'User',
      width: '18%',
      render: (data) => {
        const isMe = user && data.causer && Number(data.causer.id) === Number(user.id)
        if (isMe) return <Text variant='sm-medium'>Me</Text>
        return (
          <div>
            <Text as='div' variant='sm-medium'>
              {data.causer?.name ?? 'System Created'}
            </Text>
            {data.causer?.email ? (
              <Text as='div' variant='sm' tone='secondary' className='italic'>
                {data.causer.email}
              </Text>
            ) : null}
          </div>
        )
      },
    },
    {
      key: 'description',
      header: 'Description',
      width: '42%',
      render: (data) => (
        <Text as='div' variant='sm' className='first-letter:uppercase'>
          {data.activity_description.split('\n').map((line, index) => (
            <p key={`${data.id}-${line}-${index}`}>{line}</p>
          ))}
        </Text>
      ),
    },
    {
      key: 'model',
      header: 'Model',
      width: '22%',
      render: (data) =>
        data.subject_route && data.subject_title ? (
          <div>
            <Text as='div' variant='sm' tone='secondary'>
              <Link className='hover:underline' to={data.subject_route}>
                {data.subject_title}
              </Link>
            </Text>
            <Text as='div' variant='sm' tone='secondary' className='italic'>
              {data.subject_model_name}
            </Text>
          </div>
        ) : null,
    },
    {
      key: 'created_at',
      header: 'Created At',
      width: '18%',
      render: (data) => (
        <Text variant='sm' tone='secondary'>
          {convertToDateTime(data.created_at)}
        </Text>
      ),
    },
  ]

  return (
    <div className='cs-activity-logs min-w-0'>
      <DataTable
        caption='Activity logs'
        columns={columns}
        rows={data?.data ?? []}
        isLoading={isLoading}
        error={error}
        onRetry={refetch}
        empty={<EmptyState title='No activity logs found!' />}
        searching={searching}
        sorting={sorting}
        filtering={filtering}
        pagination={pagination}
        totalRows={data?.total}
      />
    </div>
  )
}
